// https://citrineinformatics.github.io/taurus-documentation/specification/value-types/#nominal-composition
export interface INominalCompositionValue {
  type: "nominal_composition";
  quantities: Partial<Record<string, number>>;
}

export const nominalCompositionValueToString = (
  nominalValue: INominalCompositionValue,
): string => {
  return Object.keys(nominalValue.quantities)
    .map((key) => {
      return `${key}: ${nominalValue.quantities[key]}`;
    })
    .join(", ");
};
